var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ul',{staticClass:"language-ul"},_vm._l((_vm.languages),function(language){return (language.displayName!==_vm.currentLanguage.displayName)?_c('li',{on:{"click":function($event){_vm.changeLanguage(language.name)}}},[_c('Tooltip',{attrs:{"content":language.displayName,"placement":"bottom"}},[_c('a',[_c('i',{class:language.icon})])])],1):_vm._e()}))])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a22855e","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/language-switch.vue
// module id = null
// module chunks = 